import React, { FC, useState } from "react";
import "../../../styles/homePage/table/sortTable.scss";
import { Form } from "react-bootstrap";
import { ReactComponent as SortArrow } from "../../../common/assats/table/sortArrow.svg";
import { useTranslation } from "react-i18next";
import { svgs } from "../../../common/assats";

export interface SortTableProps {
  sortKey: string;
  setSortKey: (val: string) => void;
  sortKeysArray: { name: string; val: string }[];
  setSortOrder: (str: "ASC" | "DESC") => void;
  sortOrder: "ASC" | "DESC";
  extraRowIcon?: boolean;
  toggleSelectAll?: () => void;
  allSelected: boolean;
  showCheckbox: boolean;
}
const SortTable: FC<SortTableProps> = ({
  extraRowIcon,
  sortOrder,
  setSortOrder,
  setSortKey,
  sortKey,
  sortKeysArray,
  allSelected,
  toggleSelectAll,
  showCheckbox,
}) => {
  const { t } = useTranslation();
  function getText(str: string) {
    return t(`table.sort.${str}`);
  }

  function handleSort(str: string) {
    if (str !== sortKey || sortOrder === "DESC") setSortOrder("ASC");
    else setSortOrder("DESC");

    setSortKey(str);
  }
  return (
    <div className="sort-table-main-container">
      {showCheckbox && (
        <div className="cell checkbox-cell">
          <input
            type="checkbox"
            checked={allSelected}
            onChange={toggleSelectAll}
          />
        </div>
      )}
      {/* <Form.Check inline /> */}
      {sortKeysArray.map((val, index) => (
        <div
          key={val.name + index + "asdf"}
          className={"cell"}
          onClick={() => handleSort(val.val)}
        >
          <span className={sortKey === val.val ? "bold-text" : ""}>
            {val.name}
          </span>
          {val.name && <svgs.logos.SortArrows className={`sort-icon `} />}
        </div>
      ))}
      {extraRowIcon && <div className="cell"></div>}
    </div>
  );
};

export default SortTable;
